import { supabase } from '../../../integrations/supabase/client';

export interface DailyLeadByAgent {
  date: string;
  day_name: string;
  agent_name: string;
  agent_id: string;
  count: number;
}

export interface MonthlyChartByAgent {
  month: string;
  month_name: string;
  agent_name: string;
  agent_id: string;
  count: number;
}

export interface MonthlyByAgent {
  agent_name: string;
  agent_id: string;
  current_month: number;
  previous_month: number;
}

export interface StageCount {
  stage_name: string;
  stage_color: string;
  position: number;
  count: number;
  agent_id: string;
}

export interface AgentStat {
  agent_id: string;
  today: number;
  yesterday: number;
  total: number;
}

export interface AgentOption {
  id: string;
  name: string;
}

export interface DashboardLeadStats {
  today_leads: number;
  yesterday_leads: number;
  total_leads: number;
  stats_by_agent: AgentStat[];
  daily_leads_by_agent: DailyLeadByAgent[];
  monthly_chart_by_agent: MonthlyChartByAgent[];
  monthly_by_agent: MonthlyByAgent[];
  leads_by_stage: StageCount[];
  agents: AgentOption[];
}

export async function getDashboardLeadStats(): Promise<DashboardLeadStats | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase.rpc('get_dashboard_lead_stats', { p_user_id: user.id });
  if (error) {
    console.error('getDashboardLeadStats error:', error);
    return null;
  }

  return data as DashboardLeadStats;
}
